module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      tile: _vm.pathstep.mode !== 'STile',
      stile: _vm.pathstep.mode === 'STile'
    }
  }, [_c('PinchInQue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPinchIn),
      expression: "isShowPinchIn"
    }],
    attrs: {
      "pinchInText": _vm.pinchInText,
      "pathstep": _vm.pathstep,
      "pinchInShowVoice": _vm.showQestionVoice,
      "choiceNum": _vm.choiceNum,
      "pinchInSound": _vm.pinchInSound
    },
    on: {
      "pinchOut": _vm.recievePinchOut,
      "pinchiInAudioPlay": _vm.audioPlay,
      "pinchInaudioPause": function($event) {
        return _vm.audioPause()
      }
    }
  }), _vm._v(" "), _c('PinchInActStore'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-play pinch-toparea"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelectAnswer),
      expression: "showSelectAnswer"
    }],
    staticClass: "flexstretch"
  }, [(_vm.pathstep.mode === 'STile') ? [(_vm.isEnvironmentPc()) ? [_vm._l((_vm.choiceList), function(choiceItem, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showChoice),
        expression: "showChoice"
      }],
      key: index,
      staticClass: "item",
      class: {
        disabled: _vm.choiceDisabled
      },
      attrs: {
        "id": 'choice_list_1_' + index
      },
      on: {
        "click": function($event) {
          return _vm.clickAnswer(choiceItem.text, index, 1)
        },
        "touchstart": function($event) {
          _vm.onTouchStart(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPinchInBtn),
        expression: "showPinchInBtn"
      }],
      staticClass: "icon-pinch-in",
      on: {
        "click": function($event) {
          _vm.clickPinchIn(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "icon-num1"
    }), _vm._v(" "), _c('button', {
      staticClass: "icon-voice disabled",
      on: {
        "click": function($event) {
          return _vm.choiceAudioPlay(choiceItem.text, 1)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text",
      class: _vm.getTextFontClassStile(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), _vm.productLanguage),
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text)))
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.choiceList2), function(choiceItem2, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showChoice2),
        expression: "showChoice2"
      }],
      key: index,
      staticClass: "item",
      class: {
        disabled: _vm.choiceDisabled
      },
      attrs: {
        "id": 'choice_list_2_' + index
      },
      on: {
        "click": function($event) {
          _vm.clickAnswer(choiceItem2.text, (_vm.choiceList.length + index), 2)
        },
        "touchstart": function($event) {
          _vm.onTouchStart(_vm.getDispChoiceText(choiceItem2.confuserIndex, choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPinchInBtn),
        expression: "showPinchInBtn"
      }],
      staticClass: "icon-pinch-in",
      on: {
        "click": function($event) {
          _vm.clickPinchIn(_vm.getDispChoiceText(choiceItem2.confuserIndex, choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "icon-num2"
    }), _vm._v(" "), _c('button', {
      staticClass: "icon-voice disabled",
      on: {
        "click": function($event) {
          return _vm.choiceAudioPlay(choiceItem2.text, 2)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text",
      class: _vm.getTextFontClassStile(_vm.getDispChoiceText(choiceItem2.confuserIndex, choiceItem2.confuserItemIndex, choiceItem2.text), _vm.productLanguage),
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.getDispChoiceText(choiceItem2.confuserIndex, choiceItem2.confuserItemIndex, choiceItem2.text)))
      }
    })])
  })] : [_c('div', {
    staticClass: "box-left-input"
  }, _vm._l((_vm.choiceList), function(choiceItem, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showChoice),
        expression: "showChoice"
      }],
      key: index,
      staticClass: "item",
      attrs: {
        "id": 'choice_list_1_' + index
      },
      on: {
        "click": function($event) {
          return _vm.clickAnswer(choiceItem.text, index, 1)
        },
        "touchstart": function($event) {
          _vm.onTouchStart(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPinchInBtn),
        expression: "showPinchInBtn"
      }],
      staticClass: "icon-pinch-in",
      on: {
        "click": function($event) {
          _vm.clickPinchIn(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "icon-num1"
    }), _vm._v(" "), _c('button', {
      staticClass: "icon-voice disabled",
      on: {
        "click": function($event) {
          return _vm.choiceAudioPlay(choiceItem.text, 1)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text))
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "box-right-input"
  }, _vm._l((_vm.choiceList2), function(choiceItem2, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showChoice2),
        expression: "showChoice2"
      }],
      key: index,
      staticClass: "item",
      attrs: {
        "id": 'choice_list_2_' + index
      },
      on: {
        "click": function($event) {
          _vm.clickAnswer(choiceItem2.text, (_vm.choiceList.length + index), 2)
        },
        "touchstart": function($event) {
          _vm.onTouchStart(_vm.getDispChoiceText(choiceItem2.confuserIndex, choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPinchInBtn),
        expression: "showPinchInBtn"
      }],
      staticClass: "icon-pinch-in",
      on: {
        "click": function($event) {
          _vm.clickPinchIn(_vm.getDispChoiceText(choiceItem2.confuserIndex, choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "icon-num2"
    }), _vm._v(" "), _c('button', {
      staticClass: "icon-voice disabled",
      on: {
        "click": function($event) {
          return _vm.choiceAudioPlay(choiceItem2.text, 2)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.getDispChoiceText(choiceItem2.confuserIndex, choiceItem2.confuserItemIndex, choiceItem2.text))
      }
    })])
  }), 0)]] : [_vm._l((_vm.choiceList), function(choiceItem, index) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showChoice),
        expression: "showChoice"
      }],
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "wraptext"
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPinchInBtn),
        expression: "showPinchInBtn"
      }],
      staticClass: "icon-pinch-in",
      on: {
        "click": function($event) {
          _vm.clickPinchIn(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text",
      class: _vm.isMobile() ? '' : _vm.getTextFontClassTile(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), _vm.productLanguage),
      attrs: {
        "id": 'choice_list_' + index
      },
      on: {
        "click": function($event) {
          return _vm.clickAnswer(choiceItem.text, index, 1)
        },
        "touchstart": function($event) {
          _vm.onTouchStart(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.getDispChoiceText(choiceItem.confuserIndex, choiceItem.confuserItemIndex, choiceItem.text)))
      }
    })])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQestionVoice && _vm.showChoice),
        expression: "showQestionVoice && showChoice"
      }],
      staticClass: "icon-voice disabled",
      on: {
        "click": function($event) {
          return _vm.choiceAudioPlay(choiceItem.text)
        }
      }
    })])]
  })]], 2)]), _vm._v(" "), _c('CommonAct', {
    style: (_vm.tileStyles),
    attrs: {
      "pathstep": _vm.pathstep,
      "activeType": _vm.activeType,
      "actChoice": false,
      "horizontalRow": false,
      "actTextList": _vm.actTextList,
      "isShowTextsParent": _vm.isShowTextsParent,
      "isShowVoicesParent": _vm.isShowVoicesParent,
      "isActivesParent": _vm.isActivesParent,
      "isCorrectsParent": _vm.isCorrectsParent,
      "isInCorrectsParent": _vm.isInCorrectsParent,
      "isShowAnswerParent": _vm.isShowAnswerParent,
      "changeActives": _vm.changeActives,
      "changeIsCorrects": _vm.changeIsCorrects,
      "changeIsInCorrects": _vm.changeIsInCorrects,
      "changeIsShowAnswer": _vm.changeIsShowAnswer,
      "changeEndAct": _vm.changeEndAct,
      "changeActTextList": _vm.changeActTextList,
      "scriptSystems": _vm.scriptSystems,
      "needsSwiper": true
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-905e5974", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-905e5974","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/Tile.vue
// module id = 879
// module chunks = 1